// extracted by mini-css-extract-plugin
export default {"container":"BeginnerGsapAnimation_container__Hq1ik","box":"BeginnerGsapAnimation_box__0lf2W"};